import Celebrating20YearsPage from '@/modules/Celebrating20YearsPage';

export default Celebrating20YearsPage;
